module.exports = __webpack_public_path__ + "static/lisciemobile-64b3699eb8de4a77349aaac34aa4ac32.jpg";